<template>
  <div class="chart-container" style="position: relative; height:30%; width:98%">
    <canvas ref="cpuChartEl" width="98%" height="30%">
      <p>CPU usage chart</p>
    </canvas>
  </div>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_CPU = gql`
query query_cpu_usage($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  cpu_usage (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    core_frequencies
    timestamp
  }
}
`;
const SUBSCRIPTION_CPU = gql`
subscription subscription_cpu_usage($id: String!, $timestamp: timestamptz) {
  cpu_usage (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    core_frequencies
    timestamp
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cpus: [],
      chartUI: null,
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    // wait for cpu values
    await this.getCpus();
    // create chartjs UI
    this.createChart();
    // subscribe to new cpu values
    this.subcribeNewCpus();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getCpus();
      // create chartjs UI
      if (this.chartUI) {
        this.chartUI.destroy();
      }
      this.createChart();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getCpus() {
      // Fetch cpu values
      const result = await this.$apollo.query({
        query: QUERY_CPU,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.cpus = result.data.cpu_usage.map((cpu) => ({
        timestamp: new Date(cpu.timestamp),
        core_frequencies: cpu.core_frequencies,
      }));
    },
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: []
        },
        options: {
          title: {
					  display: true,
					  text: 'CPU Frequencies (MHz)'
				  },
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              type: 'time',
              display: true,
              time: {
                tooltipFormat: 'YYYY-MM-DD HH:mm',
                displayFormats: {
                    millisecond: 'HH:mm:ss.SSS',
                    second: 'HH:mm:ss',
                    minute: 'HH:mm',
                    hour: 'HH'
                },
                unit: 'minute',
                stepSize: 30,
              },
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              display: true,
              ticks: {
                beginAtZero: true,
              }
            }]
          }
        }
      };
      const colors = [
        'red',
        'blue',
        'green',
        'cyan',
        'orange',
        'magenta',
        'purple',
        'black'
      ];
      // Create datasets
      for (let step = 0; step < 8; step++) {
        config.data.datasets.push({
          label: `CPU ${step+1}`,
          borderColor: colors[step],
          backgroundColor: colors[step],
          fill: false,
          data: [],
        });
      }

      // Push value based on array index to correct dataset
      this.cpus.forEach((cpu) => {
        const { timestamp } = cpu;
        const date = new Date(timestamp);
        if (cpu.core_frequencies) {
          cpu.core_frequencies.forEach((frequency, frequencyIndex) => {
            const value = {
              x: date,
              y: frequency,
            };

            config.data.datasets[frequencyIndex].data.push(value);
          });
        }
      });

      const { cpuChartEl } = this.$refs;
      this.chartUI = new Chart(cpuChartEl, config);
    },
    subcribeNewCpus() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new cpu values
      this.$apollo.subscribe({
        query: SUBSCRIPTION_CPU,
        variables: {
          id,
          timestamp
        },
      }).subscribe({
          next(data) {
            // got new subscription result
            if (data.data.cpu_usage.length > 0) {
              // Add new cpu value to chart
              const [cpuData] = data.data.cpu_usage;
              that.cpus.push(cpuData);
              that.addData(cpuData);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
    addData(data) {
      // create new value for chartjs
      for (let step = 0; step < 8; step++) {
        const value = {
        x: new Date(data.timestamp),
        y: data.core_frequencies[step],
      };
        this.chartUI.data.datasets[step].data.push(value);
      }

      // Update chartjs UI
      this.chartUI.update();
    },
  },
};
</script>
<style scoped>
</style>
